import * as usersApi from "../_api/usersApi";
import * as vehicleApi from "../_api/vehicleApi";

export const enrolleeService = {
  validateCode,
  validateMailer,
  updateMailer,
  register,
  sendVerifyEmail,
  sendVerifyCode,
  enrolleeVerify,
  validateReCaptcha,
  clientLogin,
  getCounties,
  loadVehicleModels,
};

function validateCode(enrollmentCode, brandIdentifier) {
  enrollmentCode = enrollmentCode?.toUpperCase();

  return usersApi
    .validateEnrollment(enrollmentCode, brandIdentifier)
    .then((user) => {
      return user;
    })
    .catch((error) => {
      throw error;
    });
}

function validateMailer(mailCode) {
  mailCode = mailCode.toUpperCase();

  return usersApi
    .validateMailer(mailCode)
    .then((user) => {
      return user;
    })
    .catch((error) => {
      throw error;
    });
}

function updateMailer(mailerObj) {
  return usersApi
    .updateMailer(mailerObj)
    .then((mail) => {
      return mail;
    })
    .catch((error) => {
      throw error;
    });
}

function register(enrolleeObj) {
  return usersApi
    .enrolleeRegister(enrolleeObj)
    .then((returnObj) => {
      return returnObj;
    })
    .catch((error) => {
      throw error;
    });
}

function sendVerifyEmail(email, brandIdentifier) {
  return usersApi
    .verifyEmail(email, brandIdentifier)
    .then((message) => {
      return message;
    })
    .catch((error) => {
      throw error;
    });
}

function sendVerifyCode(email) {
  return usersApi
    .verifyText(email)
    .then((message) => {
      return message;
    })
    .catch((error) => {
      throw error;
    });
}

function enrolleeVerify(verifyObj) {
  return usersApi
    .verifyEnrollee(verifyObj)
    .then((user) => {
      return user;
    })
    .catch((error) => {
      throw error;
    });
  // return apiUtils.post(`${baseUrl}EnrolleeVerify`, verifyObj).then((user) => {
  //   // // publish user to subscribers and start timer to refresh token
  //   // cookies.set("driveSaferUser", JSON.stringify(user), {
  //   //   path: "/",
  //   //   sameSite: "strict",
  //   // });
  //   //startRefreshTokenTimer();
  //   return user;
  // });
}

function validateReCaptcha(gToken) {
  return usersApi
    .validateReCaptcha(gToken)
    .then((decision) => {
      return decision;
    })
    .catch((error) => {
      throw error;
    });
}

function clientLogin(userName, password) {
  return usersApi
    .authenticate(userName, password)
    .then((user) => {
      return user;
    })
    .catch((error) => {
      throw error;
    });
}

function getCounties(RegionId, Type, brandIdentifier) {
  return usersApi
    .getCountyList(RegionId, Type, brandIdentifier)
    .then((countyList) => {
      return countyList;
    })
    .catch((error) => {
      throw error;
    });
}

function loadVehicleModels(code) {
  return vehicleApi
    .getVehicleModels(code)
    .then((modelList) => {
      return modelList;
    })
    .catch((error) => {
      throw error;
    });
}
